export enum ButtonCustomVariant {
    BACK_BUTTON = 'BACK_BUTTON',
    ICON_BUTTON = 'ICON_BUTTON',
}

export type TButtonCustomVariant = keyof typeof ButtonCustomVariant;
